import size from 'lodash/size';

export class DynamicMenusService {
	constructor($resource, ApiService, BreadcrumbService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.breadcrumbService = BreadcrumbService;
	}

	//Get Menu Details By Slug Url
	getMenuDetailsByUrl(url) {
		this._setResourceUrl(url);

		const promise = this.dynamicPageResource.get().$promise;
		return promise
			.then(details => {
				details.data.breadcrumb ? this.breadcrumbService.setPageBreadcrumbs(details.data.breadcrumb) : true;
				return details;
			})
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	//Add Menu Details By Slug Url
	addMenuDetailsByUrl(url, details) {
		this._setResourceUrl(url);

		const promise = this.dynamicPageResource.save(details).$promise;
		return promise
			.then(details => details)
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	//Update Menu Details By Slug Url
	updateMenuDetailsByUrl(url, details) {
		this._setResourceUrl(url);

		const promise = this.dynamicPageResource.update(details).$promise;
		return promise
			.then(details => details)
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	//Delete Menu Details By Slug Url
	deleteMenuDetailsByUrl(url) {
		this._setResourceUrl(url);

		const promise = this.dynamicPageResource.delete().$promise;
		return promise
			.then(details => details)
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	//Get Parent State Object
	getParentStateObject() {
		const breadcrumbs = this.breadcrumbService.breadcrumbs;
		const sizeOfBreadcrumbs = size(breadcrumbs);

		return sizeOfBreadcrumbs > 0 ? breadcrumbs[(sizeOfBreadcrumbs - 1) - 1] : breadcrumbs[sizeOfBreadcrumbs];
	}

	_setResourceUrl(url) {
		this.dynamicPageResourceUrl = this.apiService.getResourceUrl(`cms/menus/${url}`);
		this.dynamicPageResource = this.$resource(this.dynamicPageResourceUrl, null, {
			update: {
				method: 'PUT'
			},
			delete: {
				method: 'DELETE'
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dynamic-menus/dynamic-menus.service.js